import {
  resolveFluxmedMetaDefaultTemplateSlugKey,
  type FluxmedMetaDefaultTemplateSlug,
} from "./messageTemplateUiUtils";

export const FLUXMED_META_DEFAULT_TEMPLATE_VARIABLES_BY_SLUG: Record<
  FluxmedMetaDefaultTemplateSlug,
  readonly string[]
> = {
  agendamento_de_consulta: [
    "nome_paciente",
    "nome_clinica",
    "data_consulta",
    "hora_consulta",
    "nome_profissional",
    "especialidade",
    "endereco_consulta",
    "link_teleconsulta",
  ],
  cancelamento_de_consulta: [
    "nome_paciente",
    "nome_clinica",
    "data_consulta",
    "hora_consulta",
    "nome_profissional",
    "especialidade",
    "motivo_cancelamento",
  ],
  cobranca_de_consulta: [
    "nome_paciente",
    "tipo_consulta",
    "nome_profissional",
    "link_pagamento"
  ],
  flow_lembrete: [
    "nome_paciente",
    "nome_clinica"
  ],
  flow_medication: [
    "nome_paciente",
    "data",
    "nome_profissional",
    "especialidade",
    "nome_medicamento"
  ],
  flow_exame: [
    "nome_paciente",
    "nome_clinica",
    "nome_exame",
    "data_exame",
    "orientacao",
    "nome_profissional",
    "link_resultado",
  ],
};

export const MESSAGE_TEMPLATE_VARIABLE_LABELS: Record<string, string> = {
  nome_paciente: "Nome do paciente",
  nome_clinica: "Nome da clínica",
  data_consulta: "Data da consulta",
  hora_consulta: "Horário da consulta",
  nome_profissional: "Nome do profissional",
  especialidade: "Especialidade",
  endereco_consulta: "Endereço da consulta",
  link_teleconsulta: "Link da teleconsulta",
  motivo_cancelamento: "Motivo do cancelamento",
  valor_consulta: "Valor da consulta",
  data_vencimento: "Data de vencimento",
  link_pagamento: "Link de pagamento",
  nome_medicamento: "Nome do medicamento",
  posologia: "Posologia",
  observacao: "Observação",
  nome_exame: "Nome do exame",
  data_exame: "Data do exame",
  orientacao: "Orientação",
  link_resultado: "Link do resultado",
};

export function getMetaDefaultTemplateFixedVariables(
  slug: FluxmedMetaDefaultTemplateSlug,
): readonly string[] {
  return FLUXMED_META_DEFAULT_TEMPLATE_VARIABLES_BY_SLUG[slug];
}

export function resolveMetaDefaultTemplateFixedVariables(
  templateName: string,
  organizationPrefix?: string,
): readonly string[] | null {
  const slug = resolveFluxmedMetaDefaultTemplateSlugKey(
    templateName,
    organizationPrefix,
  );
  if (!slug) return null;
  return getMetaDefaultTemplateFixedVariables(slug);
}

export function getMessageTemplateVariableLabel(variableName: string): string {
  return (
    MESSAGE_TEMPLATE_VARIABLE_LABELS[variableName] ??
    variableName.replace(/_/g, " ")
  );
}
